import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ e('<path fill="#0052B4" d="M0 20c0 1.37.138 2.708.4 4L20 25.217 39.6 24c.262-1.292.4-2.63.4-4s-.138-2.708-.4-4L20 14.783.4 16c-.262 1.292-.4 2.63-.4 4Z"></path><path fill="#F0F0F0" d="M39.6 24H.4c1.854 9.129 9.924 16 19.6 16 9.676 0 17.746-6.871 19.6-16Z"></path><path fill="#000" d="M.4 16h39.2C37.745 6.871 29.675 0 20 0 10.324 0 2.254 6.871.4 16Z"></path><path fill="#FFDA44" d="M28.696 16H11.304l3.553-1.671-1.892-3.441 3.859.738.489-3.898L20 10.595l2.688-2.867.488 3.898 3.859-.738-1.892 3.44L28.696 16Z"></path><path fill="#A2001D" d="M0 20c0 11.046 8.954 20 20 20L4 8a19.91 19.91 0 0 0-4 12Zm20 20c11.046 0 20-8.954 20-20a19.91 19.91 0 0 0-4-12L20 40Z"></path>', 5), o = [
  l
];
function h(n, d) {
  return t(), a("svg", c, [...o]);
}
const p = { render: h };
export {
  p as default,
  h as render
};
